module.exports = __webpack_public_path__ + "static/img/fgbg2-4.2a4e08c.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-4.png
// module id = 195
// module chunks = 0